import type { InspectedPlayer } from '../../shared/protocol.ts';
import { $, el } from '../common/dom.ts';
import { typeBadges } from '../common/element-badge.ts';
import { icon } from '../common/icons.ts';
import { Modal } from '../common/modal.ts';
import { rarityBadge } from '../common/rarity-badge.ts';
import { creatureText } from '../../shared/game-config.ts';

/** « Inspecter » un autre dresseur : son équipe, dans l'ordre de combat (sans ses stats). */
export class InspectPanel extends Modal {
  private readonly team = $('.inspect-team', this.root);
  private readonly name = $('.inspect-name', this.root);

  constructor() {
    super('#inspect');
  }

  async show(username: string, load: () => Promise<InspectedPlayer | null>): Promise<void> {
    this.name.textContent = `Équipe de ${username}`;
    this.team.replaceChildren(el('p', { className: 'muted', textContent: 'Chargement…' }));
    this.open();
    const player = await load().catch(() => null);
    if (!this.isOpen) return;
    if (!player) {
      this.team.replaceChildren(el('p', { className: 'muted', textContent: `${username} n'est plus là.` }));
      return;
    }
    this.name.textContent = `Équipe de ${player.username}`;
    this.team.replaceChildren(...(player.team.length ? player.team.map((monster) => el('div', { className: `inspect-card ${monster.shiny ? 'is-shiny' : ''}` },
      el('img', { src: monster.image, alt: monster.name, className: monster.shiny ? 'shiny' : '' }),
      el('div', { className: 'inspect-body' },
        el('strong', {}, monster.name, ...(monster.shiny ? [' ', icon('sparkles', { label: 'Chromatique', className: 'shiny-mark' })] : [])),
        el('small', { className: 'muted', textContent: `${monster.name === monster.speciesName ? '' : `${monster.speciesName} · `}Nv ${monster.level}` }),
        el('div', { className: 'badges' }, ...typeBadges(monster), rarityBadge(monster.rarity))),
    )) : [el('p', { className: 'muted', textContent: creatureText('Auc{un monstre} dans son équipe.') })]));
  }
}
